import { render, staticRenderFns } from "./CustomerInvoices.vue?vue&type=template&id=782043db&scoped=true"
import script from "./CustomerInvoices.vue?vue&type=script&lang=js"
export * from "./CustomerInvoices.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoices.vue?vue&type=style&index=0&id=782043db&prod&lang=scss&scoped=true"
import style1 from "./CustomerInvoices.vue?vue&type=style&index=1&id=782043db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782043db",
  null
  
)

export default component.exports